import React from 'react'
import { Link } from 'react-router-dom'

// material ui
import Box from '@mui/material/Box'
import FormLabel from '@mui/material/FormLabel'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormHelperText from '@mui/material/FormHelperText'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio'

// components
import FormCard from 'components/atoms/FormCard'
import FormButton from 'components/atoms/FormButton'
import ErrorMessage from 'components/shared/ErrorMessage'
import FormTextFieldWithValidation from 'components/shared/FormTextFieldWithValidation'
import FormControlWithErrorHelper from 'components/shared/FormControlWithErrorHelper'

import { relationshipToCampersOptions } from './selectionOptions'

const EmergencyContactForm = props => {
  const {
    form,
    onChangeFormField,
    mutationLoading,
    handleSubmit,
    formErrors,
    buttonText,
    redirect,
    showFormFields = true
  } = props

  return (
    <FormCard>
      <ErrorMessage />
      {showFormFields && (
        <form>
          <FormTextFieldWithValidation
            label='First Name'
            field='firstName'
            form={form}
            onChange={onChangeFormField}
            errors={formErrors}
            required
          />
          <FormTextFieldWithValidation
            label='Last Name'
            field='lastName'
            form={form}
            onChange={onChangeFormField}
            errors={formErrors}
            required
          />
          <FormControlWithErrorHelper
            required
            errorsObject={formErrors}
            errorField='relationshipToCampers'
          >
            <FormLabel htmlFor='relationshipToCampers'>
              Relationship To Child/Children
            </FormLabel>
            <Select
              id='relationshipToCampers'
              value={form.relationshipToCampers}
              onChange={onChangeFormField('relationshipToCampers')}
              variant='outlined'
              displayEmpty
              fullWidth
              name='relationshipToCampers'
              inputProps={{
                name: 'relationshipToCampers',
                id: 'relationshipToCampers'
              }}
            >
              {relationshipToCampersOptions.map(option => (
                <MenuItem key={option} value={option.toLowerCase()}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControlWithErrorHelper>
          <FormControlWithErrorHelper
            component='fieldset'
            required
            errorsObject={formErrors}
            errorField='legalGuardian'
          >
            <FormLabel component='legend' htmlFor='legalGuardian'>
              Is this adult a Legal Guardian?
            </FormLabel>
            <RadioGroup
              id='legalGuardian'
              value={form.legalGuardian}
              onChange={onChangeFormField('legalGuardian')}
              aria-label='legalGuardian'
              name='legalGuardian'
            >
              <FormControlLabel value='true' control={<Radio />} label='Yes' />
              <FormControlLabel value='false' control={<Radio />} label='No' />
            </RadioGroup>
          </FormControlWithErrorHelper>
          <FormTextFieldWithValidation
            label='Daytime Phone (with area code)'
            field='primaryPhone'
            form={form}
            onChange={onChangeFormField}
            errors={formErrors}
            required
          >
            <FormHelperText>
              Fastest way to reach Emergency Contact during business hours.
            </FormHelperText>
            <FormHelperText>International: +## ### ### ###</FormHelperText>
          </FormTextFieldWithValidation>
          <FormTextFieldWithValidation
            label='Alternate Phone (with area code)'
            field='alternatePhone'
            form={form}
            onChange={onChangeFormField}
            errors={formErrors}
          >
            <FormHelperText>International: +## ### ### ###</FormHelperText>
          </FormTextFieldWithValidation>
          <FormControlWithErrorHelper
            component='fieldset'
            required
            errorsObject={formErrors}
            errorField='pickup'
          >
            <FormLabel htmlFor='pickup' component='legend'>
              Authorized for pick-up?
            </FormLabel>
            <RadioGroup
              id='pickup'
              value={form.pickup != null && form.pickup.toString()}
              onChange={onChangeFormField('pickup')}
              aria-label='pickup'
              name='pickup'
            >
              <FormControlLabel value='true' control={<Radio />} label='Yes' />
              <FormControlLabel value='false' control={<Radio />} label='No' />
            </RadioGroup>
          </FormControlWithErrorHelper>
          <Box py={2} align='center'>
            <FormButton variant='outlined' component={Link} to={redirect}>
              Cancel
            </FormButton>
            <FormButton
              variant='contained'
              color='secondary'
              disabled={mutationLoading}
              onClick={handleSubmit}
            >
              {buttonText}
            </FormButton>
          </Box>
        </form>
      )}
    </FormCard>
  )
}

export default EmergencyContactForm
